module.exports = __webpack_public_path__ + "img/6.19e7d871.png";